import React from 'react';

const PlayIcon = props => {
  return (
    <svg width="33" height="39" viewBox="0 0 33 39" fill="none" {...props}>
      <path
        d="M0.199219 19.2008V0.300781L16.3992 10.0208L32.5992 19.2008L16.3992 28.3808L0.199219 38.1008V19.2008Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlayIcon;
